/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_norm_field_normality = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normality (N)`)
};

const es_norm_field_normality = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalidad (N)`)
};

const de_norm_field_normality = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalität (N)`)
};

const nl_norm_field_normality = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normaliteit (N)`)
};

const fr_norm_field_normality = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalité (N)`)
};

const it_norm_field_normality = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalità (N)`)
};

const pt_br2_norm_field_normality = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalidade (N)`)
};

const pt_norm_field_normality = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalidade (N)`)
};

const ja_norm_field_normality = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`規定度 (N)`)
};

const zh_norm_field_normality = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当量浓度（N）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const norm_field_normality = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.norm_field_normality(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("norm_field_normality", locale)
	if (locale === "en") return en_norm_field_normality(inputs)
	if (locale === "es") return es_norm_field_normality(inputs)
	if (locale === "de") return de_norm_field_normality(inputs)
	if (locale === "nl") return nl_norm_field_normality(inputs)
	if (locale === "fr") return fr_norm_field_normality(inputs)
	if (locale === "it") return it_norm_field_normality(inputs)
	if (locale === "pt-BR") return pt_br2_norm_field_normality(inputs)
	if (locale === "pt") return pt_norm_field_normality(inputs)
	if (locale === "ja") return ja_norm_field_normality(inputs)
	return zh_norm_field_normality(inputs)
};